import { InlinePaymentEngineView } from './inline-payment-engine.view';
import { UtilService } from '../shared/util.service';
import { PaymentEngineOptions } from './payment-engine-options';
import { RmIframeEventType } from '../shared/models/rm-iframe-event-type';
import { ChargeResponse } from '../shared/models/charge-response.model';
import { Validators } from '../shared/validators';

export class InlinePaymentEngineComponent {
    view: InlinePaymentEngineView;
    defaultOptions: PaymentEngineOptions;
    isIframeLoaded: boolean;
    isIframeOpen: boolean;
    eventMethod: any;
    messageEvent: any;
    eventer: any;
    siteBaseUrl: string;
    htmlPath: string;
    readonly INLINE_SCRIPT_NAME = 'remita-pay-inline';
    readonly IFRAME_CLASS_NAME = 'iframe-pop';
    readonly APP_LOADER_ID = 'js-app-loader';
    readonly OMITTED_PAYMENT_KEYS = ["onClose", "onSuccess", "onError"];

    constructor() {
        this.view = new InlinePaymentEngineView();
    }

    init(options: any) {
        this.view.setupAppLoader(this.APP_LOADER_ID);
        try {
            if (this.isValidPaymentOptions(options)) {
                this.eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                this.eventer = (window as any)[this.eventMethod];
                this.messageEvent = "attachEvent" == this.eventMethod ? "onmessage" : "message";

                options.transactionId = options.transactionId || UtilService.randomId();
                options.id = options.transactionId;
                this.defaultOptions = new PaymentEngineOptions(options);
                UtilService.log("[InlinePaymentEngineComponent]", 'Site Base ', this.siteBaseUrl)
                this.siteBaseUrl = ("undefined" !== typeof options.config && options.config.host) ? options.config.host : this.getInlineScriptPathUrl();
                if ("undefined" !== typeof options.config && !options.config.host) {
                    options.config.host = this.siteBaseUrl;
                }
                this.htmlPath = `${this.siteBaseUrl}/base-template.html`;

                this.buildPaymentWidget(this.defaultOptions);
                this.listenForCloseEvent();

                UtilService.log("[InlinePaymentEngineComponent]", 'init component', options);
                UtilService.log("[InlinePaymentEngineComponent]", 'init component this.defaultOptions', this.defaultOptions);
            }
        } catch (e) {
            this.addDataCollectionFormBehaviour(options, e);
            if (!e.publickey || !e.narration) {
                this.view.showPublicKeyError(this.APP_LOADER_ID, options, e);
            } else {
                this.view.showInfoCollectionForm(this.APP_LOADER_ID, options, e);
            }
        }

        return this;
    }

    addDataCollectionFormBehaviour(options: any, e: any) {
        document.getElementById(this.APP_LOADER_ID).addEventListener("click", event => {
            if ((event.target as HTMLButtonElement).matches('.close-data-collect')) {
                document.body.style.overflow = "";
                this.closePaymentWidget();
            }
        });
        document.getElementById(this.APP_LOADER_ID).addEventListener("submit", event => {
            if ((event.target as HTMLFormElement).matches('#data-collect-form')) {
                if (!e.firstName) {
                    options.firstName = (document.getElementById('data-collect-firstName') as HTMLInputElement).value;
                }

                if (!e.lastName) {
                    options.lastName = (document.getElementById('data-collect-lastName') as HTMLInputElement).value;
                }

                if (!e.email) {
                    options.email = (document.getElementById('data-collect-email') as HTMLInputElement).value;
                }

                if (!e.amount) {
                    options.amount = (document.getElementById('data-collect-amount') as HTMLInputElement).value;
                }
                this.removeAppLoadingView();
                this.init(options).showPaymentWidget();

            }

            event.stopPropagation();
        });
    }

    getInlineScriptPathUrl(): string {
        const scripts = document.getElementsByTagName('script');
        let pathUrl = "https://login.remita.net/payment/v1";
        for (let i = 0; i < scripts.length; i++) {
            let item = scripts[i];
            if (item && item.src) {
                let index = item.src.indexOf(this.INLINE_SCRIPT_NAME);
                if (index != -1) {
                    pathUrl = item.src.substring(0, index - 1);
                    break;
                }
            }
        }
        return pathUrl;
    }

    initNew(options: any) {
        UtilService.log("[InlinePaymentEngineComponent]", 'Stating inline initialization')
    }

    isValidPaymentOptions(options: PaymentEngineOptions) {

        if (options) {
            if (!options.processRrr) {
                const isFirstNameValid = (Validators.isString(options.firstName) && options.firstName.length > 0);

                const isLastNameValid = (Validators.isString(options.lastName) && options.lastName.length > 0);

                const isEmailValid = (Validators.isString(options.email) && options.email.length > 0);

                const isAmountValid = (Validators.isNumber(parseFloat(options.amount)));

                const isKeyValid = (Validators.isString(options.key) && options.key.length > 0);

                const isNarrationValid = (Validators.isString(options.narration) && options.narration.length > 0);

                if (!isFirstNameValid || !isLastNameValid || !isEmailValid || !isAmountValid || !isKeyValid || !isNarrationValid) {
                    throw {
                        firstName: isFirstNameValid,
                        lastName: isLastNameValid,
                        email: isEmailValid,
                        amount: isAmountValid,
                        publickey: isKeyValid,
                        narration: isNarrationValid
                    };
                }
            }
        } else {
            throw new Error('Please provide the required payment options to continue.');
        }


        return true;
    }

    buildPaymentWidget(options: PaymentEngineOptions) {
        UtilService.log("[InlinePaymentEngineComponent]", 'building payment widget');
        this.isIframeLoaded = false;
        this.isIframeOpen = false;
        options.metadata.referrer = this.view.getWindowHref();
        options.metadata = JSON.stringify(options.metadata);
        options.extendedData = JSON.stringify(options.extendedData);
        options.config = JSON.stringify(options.config);
        let params = this.view.deleteKeysFromObject(options, this.OMITTED_PAYMENT_KEYS);
        UtilService.log("[InlinePaymentEngineComponent]", 'params', params);
        let iframeSrcPath = this.htmlPath + "?" + this.view.serialize(params);
        this.setupPaymentWidget(iframeSrcPath);
        UtilService.log("[InlinePaymentEngineComponent]", 'params', { options, params, iframeSrcPath });
    }

    setupPaymentWidget(iframeSrcPath: string) {
        let zIndex = 10 * this.view.getHighestZIndex("div");
        let cssText = "z-index: " + Math.max(zIndex, 999999);
        cssText += `
        ;\ndisplay: none;
        \nbackground: transparent;
        \nbackground: rgba(0,0,0,0.005);
        \nborder: 0px none transparent;
        \noverflow-x: hidden;
        \noverflow-y: hidden;
        \nvisibility: hidden;
        \nmargin: 0;
        \npadding: 0;
        \n-webkit-tap-highlight-color: transparent;
        \n-webkit-touch-callout: none; position: fixed;
        \nleft: 0;
        \ntop: 0;
        \nwidth: 100%;
        \nheight: 100%;
        `;
        const iframe: HTMLIFrameElement = this.view.appendPaymentIframe(
            {
                id: this.defaultOptions.id,
                src: iframeSrcPath,
                cssText: cssText,
                className: this.IFRAME_CLASS_NAME,
                parent: document.body,
                disableSandboxMode: this.defaultOptions.disableSandboxMode
            }
        );

        iframe.onload = () => {
            this.isIframeLoaded = true;
        }
    }

    listenForCloseEvent() {
        try {
            window.addEventListener(this.messageEvent, (event: any) => {
                let data = event.data || event.message;

                if (data && ("string" === typeof data)) {
                    let response = this.view.parseResponse(data, this.defaultOptions);
                    if (!response.isIframe) {
                        return;
                    }
                    this.handleIframeEvents(response);
                }
            }, false);
        } catch (e) {
            UtilService.error("[InlinePaymentEngineComponent]", 'CloseEventException ', e);
        }
    }

    private handleIframeEvents(response: { action: any; isIframe: any; data: any }) {
        const responseAction = response.action;
        const responseData = response.data;

        switch (responseAction) {
            case RmIframeEventType.RemitaCloseAppLoader:
                this.removeAppLoadingView();
                break;
            case RmIframeEventType.RemitaClose:
                if (responseData) {
                    this.handleSuccess(responseData);
                } else {
                    this.performCloseEvent();
                }
                break;
            case RmIframeEventType.RemitaError:
                if (responseData) {
                    this.handleError(responseData);
                }
                break;
            case RmIframeEventType.RemitaConfigError:
                this.handleConfigError(responseData);
                break;
            case RmIframeEventType.RemitaOpen:
                break;
            default:
                this.closePaymentWidget();
                break;
        }
    }

    displayPaymentIframe(iframe: HTMLIFrameElement) {
        let receiver = iframe.contentWindow;
        receiver.postMessage(RmIframeEventType.RemitaOpen + " " + this.defaultOptions.id, "*");
        this.isIframeOpen = true;
        this.view.displayPaymentIframe(this.defaultOptions.id);
    }

    // deprecated
    openIframe() {
        // this.setCookies();
        this.showPaymentWidget();
    }

    showPaymentWidget() {
        let iframe: HTMLIFrameElement;
        if (!this.isIframeOpen && this.defaultOptions && this.defaultOptions.id) {
            iframe = <HTMLIFrameElement>document.getElementById(this.defaultOptions.id);
            if (this.isIframeLoaded) {
                this.displayPaymentIframe(iframe)
            } else {
                iframe.onload = () => {
                    this.displayPaymentIframe(iframe);
                    this.isIframeLoaded = true;
                }
            }
        }
    }

    closePaymentWidget() {
        if (this.isIframeOpen) {
            this.isIframeOpen = false;
            this.view.hidePaymentIframe(this.defaultOptions.id);
        }
        this.removeAppLoadingView();
    }

    removeAppLoadingView() {
        const appLoaderEl = document.getElementById(this.APP_LOADER_ID);
        if (appLoaderEl) {
            appLoaderEl.remove();
        }
    }

    handleSuccess(response: any): any {
        const chargeResponse: ChargeResponse = new ChargeResponse(JSON.parse(response));
        if (this.defaultOptions.onSuccess) {
            this.defaultOptions.onSuccess.call(this, chargeResponse);
            this.performCloseEvent();
        }
    }

    handleError(response: any): any {
        let failureResponse: ChargeResponse = new ChargeResponse(JSON.parse(response));
        if (this.defaultOptions.onError) {
            if (failureResponse) {
                this.defaultOptions.onError.call(this, failureResponse);
            }
        }
    }

    handleConfigError(response: any): any {
        let failureResponse: ChargeResponse = new ChargeResponse(JSON.parse(response));
        if (this.defaultOptions.onError) {
            if (failureResponse) {
                this.defaultOptions.onError.call(this, failureResponse);
                this.performCloseEvent();
            }
        }
    }

    private performCloseEvent() {
        if (this.defaultOptions.onClose) {
            this.defaultOptions.onClose.call(this);
            this.closePaymentWidget();
        }
    }

}



// WEBPACK FOOTER //
// ../inline/src/modules/inline-payment-engine/inline-payment-engine.component.ts